"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabPanel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TabPanelMixin = require("../../mixins/components/TabPanelMixin");
var StyledTabPanel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledTabPanel",
  componentId: "c11n-8-107-0__sc-1d0sn23-0"
})(["", ""], _TabPanelMixin.TabPanelMixin);
exports.StyledTabPanel = StyledTabPanel;